import { hostHas, type HostFeature } from '../shared/host-capabilities';
import type { WorkspaceSectionItem } from './WorkspaceSections';
import type { SettingsSection } from './SpeedCheck';

/** The host feature each Settings section shows; a section with none is on every host. */
const sectionFeature: Partial<Record<SettingsSection, HostFeature>> = {
  performance: 'local-performance',
  cluster: 'shared-processing',
  storage: 'local-storage',
  updates: 'software-updates',
  license: 'licensing',
  connections: 'saved-connections',
  support: 'support-access',
};

/** The Settings sections this host has, in the order given; the desktop keeps every one. */
export function hostSettingsSections(
  sections: readonly WorkspaceSectionItem<SettingsSection>[],
): readonly WorkspaceSectionItem<SettingsSection>[] {
  return sections.filter((section) => {
    const feature = sectionFeature[section.id];
    return feature === undefined || hostHas(feature);
  });
}
